import React from 'react';
import Card from './Card';
import styles from './ThemCard.module.scss';
const ThemeCard = ({ data, chatSettingsThemeData, id, isCustom }) => {
  return (
    <div className={styles.cont}>
      {data &&
        data?.map((item) => {
          return (
            <Card
              item={item}
              key={item[id]}
              activeVoice={chatSettingsThemeData?.data?.responseThemeId}
              id={id}
              isCustom={isCustom}
            />
          );
        })}
    </div>
  );
};
export default ThemeCard;
